import * as yup from 'yup';

const SocialDeterminantsSchema = yup.object({
  status: yup.string().required('Level is required'),
  notes: yup.string().required('Notes is required'),
});

export { SocialDeterminantsSchema };
